const process = {"env":{},"argv":[]};

const between = (x, min, max) => x >= min && x <= max;

const buildFutureDate = (days) => {
    const newDate = new Date();
    newDate.setDate(newDate.getDate() + days);
    return newDate;
};
const buildPastDate = (days) => buildFutureDate(-days);
const getDaysFromToday = (date) => {
    const today = new Date();
    const diffTime = date.getTime() - today.getTime();
    return Math.abs(Math.ceil(diffTime / (1000 * 60 * 60 * 24)));
};
const getHoursFromMilliseconds = (milliseconds) => Math.ceil(milliseconds / 1000 / 60 / 60);
const getMinutesFromMilliseconds = (milliseconds) => Math.ceil(milliseconds / 1000 / 60);
const getDaysSince = (date) => {
    if (date === undefined) {
        return undefined;
    }
    const difference = new Date().getTime() - date.getTime();
    return Math.ceil(difference / (1000 * 3600 * 24));
};

const isObject = (value) => typeof value === 'object' && value !== null && !Array.isArray(value);
const diff = (obj1, obj2) => {
    const result = {};
    // Helper function to process each key
    function processKey(key) {
        const value1 = obj1[key];
        const value2 = obj2[key];
        if (isObject(value1) && isObject(value2)) {
            const nestedDiff = diff(value1, value2);
            if (Object.keys(nestedDiff).length > 0) {
                result[key] = nestedDiff;
            }
        }
        else if (value1 !== value2) {
            result[key] = [value1, value2];
        }
    }
    // Process keys from obj12
    Object.keys(obj1).forEach(processKey);
    // Process keys from obj2 that are not in obj1
    Object.keys(obj2).forEach((key) => {
        if (!(key in obj1)) {
            result[key] = [undefined, obj2[key]];
        }
    });
    return result;
};
const merge = (obj1, obj2) => {
    const result = { ...obj1 };
    Object.keys(obj2).forEach((key) => {
        if (typeof obj2[key] === 'object' && obj2[key] !== null && !Array.isArray(obj2[key])) {
            result[key] = merge(result[key] ?? {}, obj2[key]);
        }
        else {
            result[key] = obj2[key];
        }
    });
    return result;
};
const areDeepEqual = (obj1, obj2) => {
    if (obj1 === obj2) {
        return true;
    }
    if (typeof obj1 !== 'object' || typeof obj2 !== 'object' || obj1 == null || obj2 == null) {
        return false;
    }
    const keysA = Object.keys(obj1);
    const keysB = Object.keys(obj2);
    if (keysA.length !== keysB.length) {
        return false;
    }
    let result = true;
    keysA.forEach((key) => {
        if (!keysB.includes(key)) {
            result = false;
        }
        if (typeof obj1[key] === 'function' || typeof obj2[key] === 'function') {
            if (obj1[key].toString() !== obj2[key].toString()) {
                result = false;
            }
        }
        if (!areDeepEqual(obj1[key], obj2[key])) {
            result = false;
        }
    });
    return result;
};

function sha1(text) {
    function rotateLeft(n, s) {
        return (n << s) | (n >>> (32 - s));
    }
    function cvtHex(val) {
        let str = '';
        for (let i = 7; i >= 0; i--) {
            const v = (val >>> (i * 4)) & 0x0f;
            str += v.toString(16);
        }
        return str;
    }
    function utf8Encode(input) {
        const result = input.replace(/\r\n/g, '\n');
        let utfText = '';
        for (let n = 0; n < result.length; n++) {
            const c = result.charCodeAt(n);
            if (c < 128) {
                utfText += String.fromCharCode(c);
            }
            else if (c < 2048) {
                utfText += String.fromCharCode((c >> 6) | 192);
                utfText += String.fromCharCode((c & 63) | 128);
            }
            else {
                utfText += String.fromCharCode((c >> 12) | 224);
                utfText += String.fromCharCode(((c >> 6) & 63) | 128);
                utfText += String.fromCharCode((c & 63) | 128);
            }
        }
        return utfText;
    }
    let blockStart;
    let i;
    let j;
    const W = new Array(80);
    let H0 = 0x67452301;
    let H1 = 0xefcdab89;
    let H2 = 0x98badcfe;
    let H3 = 0x10325476;
    let H4 = 0xc3d2e1f0;
    let A;
    let B;
    let C;
    let D;
    let E;
    let temp;
    const result = utf8Encode(text);
    const msgLen = result.length;
    const wordArray = [];
    for (i = 0; i < msgLen - 3; i += 4) {
        j =
            (result.charCodeAt(i) << 24) |
                (result.charCodeAt(i + 1) << 16) |
                (result.charCodeAt(i + 2) << 8) |
                result.charCodeAt(i + 3);
        wordArray.push(j);
    }
    switch (msgLen % 4) {
        case 0:
            i = 0x080000000;
            break;
        case 1:
            i = (result.charCodeAt(msgLen - 1) << 24) | 0x0800000;
            break;
        case 2:
            i = (result.charCodeAt(msgLen - 2) << 24) | (result.charCodeAt(msgLen - 1) << 16) | 0x08000;
            break;
        case 3:
            i =
                (result.charCodeAt(msgLen - 3) << 24) |
                    (result.charCodeAt(msgLen - 2) << 16) |
                    (result.charCodeAt(msgLen - 1) << 8) |
                    0x80;
            break;
    }
    wordArray.push(i);
    while (wordArray.length % 16 !== 14) {
        wordArray.push(0);
    }
    wordArray.push(msgLen >>> 29);
    wordArray.push((msgLen << 3) & 0x0ffffffff);
    for (blockStart = 0; blockStart < wordArray.length; blockStart += 16) {
        for (i = 0; i < 16; i++) {
            W[i] = wordArray[blockStart + i];
        }
        for (i = 16; i <= 79; i++) {
            W[i] = rotateLeft(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1);
        }
        A = H0;
        B = H1;
        C = H2;
        D = H3;
        E = H4;
        for (i = 0; i <= 19; i++) {
            temp = (rotateLeft(A, 5) + ((B & C) | (~B & D)) + E + W[i] + 0x5a827999) & 0x0ffffffff;
            E = D;
            D = C;
            C = rotateLeft(B, 30);
            B = A;
            A = temp;
        }
        for (i = 20; i <= 39; i++) {
            temp = (rotateLeft(A, 5) + (B ^ C ^ D) + E + W[i] + 0x6ed9eba1) & 0x0ffffffff;
            E = D;
            D = C;
            C = rotateLeft(B, 30);
            B = A;
            A = temp;
        }
        for (i = 40; i <= 59; i++) {
            temp =
                (rotateLeft(A, 5) + ((B & C) | (B & D) | (C & D)) + E + W[i] + 0x8f1bbcdc) & 0x0ffffffff;
            E = D;
            D = C;
            C = rotateLeft(B, 30);
            B = A;
            A = temp;
        }
        for (i = 60; i <= 79; i++) {
            temp = (rotateLeft(A, 5) + (B ^ C ^ D) + E + W[i] + 0xca62c1d6) & 0x0ffffffff;
            E = D;
            D = C;
            C = rotateLeft(B, 30);
            B = A;
            A = temp;
        }
        H0 = (H0 + A) & 0x0ffffffff;
        H1 = (H1 + B) & 0x0ffffffff;
        H2 = (H2 + C) & 0x0ffffffff;
        H3 = (H3 + D) & 0x0ffffffff;
        H4 = (H4 + E) & 0x0ffffffff;
    }
    const tempResult = cvtHex(H0) + cvtHex(H1) + cvtHex(H2) + cvtHex(H3) + cvtHex(H4);
    return tempResult.toLowerCase();
}
const str = () => 
// eslint-disable-next-line
`00000000000000000${(Math.random() * 0xffffffffffffffff).toString(16)}`.slice(-16);
const randomUUID = () => {
    const a = str();
    const b = str();
    return `${a.slice(0, 8)}-${a.slice(8, 12)}-4${a.slice(13)}-a${b.slice(1, 4)}-${b.slice(4)}`;
};
const generateRandomUUID = () => {
    if (typeof crypto !== 'undefined' && crypto.randomUUID) {
        return crypto.randomUUID();
    }
    return randomUUID();
};
const hash = (text) => sha1(text);
const getDeviceId = () => {
    let deviceId = localStorage.getItem('wf.device');
    if (!deviceId) {
        deviceId = generateRandomUUID();
        localStorage.setItem('wf.device', deviceId);
    }
    return deviceId;
};
const base64URLEncode = (value) => btoa(String.fromCharCode(...new Uint8Array(value)))
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/, '');
// Function to generate a code verifier
function generateCodeVerifier() {
    const array = new Uint8Array(32);
    window.crypto.getRandomValues(array);
    return base64URLEncode(array.buffer);
}
// Function to generate a code challenge from the code verifier
async function generateCodeChallenge(codeVerifier) {
    const encoder = new TextEncoder();
    const data = encoder.encode(codeVerifier);
    const digest = await window.crypto.subtle.digest('SHA-256', data);
    return base64URLEncode(digest);
}

const whitespaceRegex = /[\s\u0020\u00A0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000.,:;?!"()[\]]+/;
const cjkRegex = /[\u4E00-\u9FFF\u3040-\u309F\u30A0-\u30FF\uAC00-\uD7AF]/g;
const splitWords = (text) => {
    if (!text || text.trim().length === 0) {
        return [];
    }
    // Split by whitespace and filter out empty strings
    const words = text
        .replace(cjkRegex, '$& ')
        .split(whitespaceRegex)
        .filter((word) => word.length > 0);
    return words;
};
const countWords = (text) => splitWords(text).length;

const debounce = (callback, wait) => {
    let timerId;
    return (...args) => {
        clearTimeout(timerId);
        timerId = setTimeout(() => {
            callback(...args);
        }, wait);
    };
};
const throttle = (callback, wait) => {
    let isRunning = false;
    return (...args) => {
        if (!isRunning) {
            isRunning = true;
            callback(...args);
            setTimeout(() => {
                isRunning = false;
            }, wait);
        }
    };
};
const debouncePromise = (fn, wait, abortValue = undefined) => {
    let cancel = () => {
        // do nothing
    };
    const wrapFunc = (...args) => {
        cancel();
        return new Promise((resolve, reject) => {
            const timer = setTimeout(() => resolve(fn(...args)), wait);
            cancel = () => {
                clearTimeout(timer);
                if (abortValue !== undefined) {
                    reject(abortValue);
                }
            };
        });
    };
    return wrapFunc;
};
const delay = (callback, timeout) => new Promise((resolve) => {
    setTimeout(() => {
        callback();
        resolve();
    }, timeout);
});

const isSafari = () => /^((?!chrome|android).)*safari/i.test(navigator?.userAgent);
const copyToClipboard = async (text) => {
    // Check if the Clipboard API is available
    try {
        return await navigator.clipboard.writeText(text);
    }
    catch {
        // Fallback for browsers that do not support the Clipboard API
        const textArea = document.createElement('textarea');
        textArea.value = text;
        document.body.appendChild(textArea);
        textArea.select();
        try {
            document.execCommand('copy');
        }
        catch (error) {
            console.error('Error copying text to clipboard: ', error);
        }
        document.body.removeChild(textArea);
        return Promise.resolve();
    }
};

function clsx(...args) {
    return args
        .flat()
        .filter((x) => typeof x === 'string')
        .join(' ')
        .trim();
}

function isJSXElement(element) {
    return (typeof element === 'object' &&
        element !== null &&
        element.$$typeof === Symbol.for('react.element'));
}
function isFunctionComponent(component) {
    return (typeof component === 'function' &&
        (component.prototype?.isReactComponent === undefined || isJSXElement(component({}))) // Check by calling it with an empty props object
    );
}

const toBase64 = (file) => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
});

const addCssStyle = (cssRule, id) => {
    if (document.getElementById(id)) {
        return;
    }
    const style = document.createElement('style');
    document.head.appendChild(style);
    style.setAttribute('id', id);
    style.sheet.insertRule(cssRule, 0);
};
const removeCssStyle = (id) => {
    const style = document.getElementById(id);
    if (style) {
        document.head.removeChild(style);
    }
};

const buildOptionsUsed = (optionsAvailable, optionsUsed) => {
    if (!optionsAvailable?.length) {
        return {};
    }
    const keys = optionsAvailable.map((o) => o.key);
    if (optionsUsed.promptEnabled && optionsUsed.prompt.length) {
        return {
            advancedOptions: 'On',
            prompt: 'On',
            ...keys.reduce((acc, key) => ({ ...acc, [key]: 'Off' }), {}),
        };
    }
    const options = keys.reduce((acc, option) => ({
        ...acc,
        [option]: (optionsUsed.values[option]?.length ? 'On' : 'Off'),
    }), {});
    const areAllOptionsOff = Object.values(options).every((value) => value === 'Off');
    if (areAllOptionsOff) {
        return { advancedOptions: 'Off' };
    }
    return {
        advancedOptions: 'On',
        prompt: 'Off',
        ...options,
    };
};

export { addCssStyle, areDeepEqual, between, buildFutureDate, buildOptionsUsed, buildPastDate, clsx, copyToClipboard, countWords, debounce, debouncePromise, delay, diff, generateCodeChallenge, generateCodeVerifier, generateRandomUUID, getDaysFromToday, getDaysSince, getDeviceId, getHoursFromMilliseconds, getMinutesFromMilliseconds, hash, isFunctionComponent, isJSXElement, isSafari, merge, removeCssStyle, splitWords, throttle, toBase64 };
//# sourceMappingURL=index.js.map
